import React from "react";
import PropTypes from "prop-types";
import "./EditUserModal.css";

const UserProfileModal = ({ show, onHide, user, onEdit }) => {
  if (!show || !user) return null;

  const handleOverlayClick = (e) => {
    if (e.target.className === 'modal-overlay') {
      onHide();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content">
        <div className="modal-header">
          <h2>Profil de {user.firstName} {user.lastName}</h2>
          <button className="close-button" onClick={onHide}>
            ✕
          </button>
        </div>

        <div className="modal-body">
          <div className="form-section">
            <h3 className="profile-section-title">Informations personnelles</h3>
            
            <div className="profile-info-row">
              <div className="profile-info-label">Identifiant :</div>
              <div className="profile-info-value">{user.identifier || `${user.firstName?.substring(0, 3)}${user.lastName?.substring(0, 3)}`}</div>
            </div>
            
            <div className="profile-info-row">
              <div className="profile-info-label">Prénom :</div>
              <div className="profile-info-value">{user.firstName}</div>
            </div>
            
            <div className="profile-info-row">
              <div className="profile-info-label">Nom :</div>
              <div className="profile-info-value">{user.lastName}</div>
            </div>
            
            <div className="profile-info-row">
              <div className="profile-info-label">Email :</div>
              <div className="profile-info-value">{user.email}</div>
            </div>
            
            <div className="profile-info-row">
              <div className="profile-info-label">Téléphone :</div>
              <div className="profile-info-value">{user.telephone || "Non renseigné"}</div>
            </div>
          </div>

          <div className="form-section">
            <h3 className="profile-section-title">Informations professionnelles</h3>
            
            <div className="profile-info-row">
              <div className="profile-info-label">Statut :</div>
              <div className="profile-info-value">{user.statut}</div>
            </div>
            
            <div className="profile-info-row">
              <div className="profile-info-label">Service principal :</div>
              <div className="profile-info-value">{user.service_principal || "Non renseigné"}</div>
            </div>
            
            <div className="profile-info-row">
              <div className="profile-info-label">Concession :</div>
              <div className="profile-info-value">{user.concession_nom || "Non renseigné"}</div>
            </div>
            
            <div className="profile-info-row">
              <div className="profile-info-label">Ville :</div>
              <div className="profile-info-value">{user.ville}</div>
            </div>
            
            <div className="profile-info-row">
              <div className="profile-info-label">SIRET :</div>
              <div className="profile-info-value">{user.siret}</div>
            </div>
            
            <div className="profile-info-row">
              <div className="profile-info-label">SIREN :</div>
              <div className="profile-info-value">{user.siren || "Non renseigné"}</div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button type="button" className="button secondary" onClick={onHide}>
            Fermer
          </button>
          <button 
            type="button" 
            className="button primary" 
            onClick={() => {
              onHide();
              onEdit(user);
            }}
          >
            Modifier
          </button>
        </div>
      </div>
    </div>
  );
};

UserProfileModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  user: PropTypes.shape({
    id: PropTypes.number,
    email: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    statut: PropTypes.string,
    ville: PropTypes.string,
    concessions_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    concession_nom: PropTypes.string,
    siret: PropTypes.string,
    siren: PropTypes.string,
    telephone: PropTypes.string,
    service_principal: PropTypes.string,
    identifier: PropTypes.string,
  }),
};

export default UserProfileModal; 